import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  contentContainerStyle: {
    marginTop: 12,
    flex: 1,
  },
  detailsTitleStyle: theme => ({
    color: theme.colors.text.primary,
    fontSize: 24,
    marginTop: 27,
    textAlign: 'center',
    marginHorizontal: 16,
    fontWeight: 'bold',
  }),
  detailsDescriptionStyle: theme => ({
    color: theme.colors.text.primary,
    fontSize: 16,
    marginTop: 7.5,
    textAlign: 'center',
    lineHeight: 24,
    marginHorizontal: 16,
  }),
  detailsSecondTitleStyle: theme => ({
    color: theme.colors.text.primary,
    fontSize: 24,
    marginTop: 27,
    textAlign: 'center',
    marginHorizontal: 36,
    fontWeight: 'bold',
  }),
  detailsSecondDescriptionStyle: theme => ({
    color: theme.colors.text.primary,
    fontSize: 16,
    marginTop: 8.8,
    textAlign: 'center',
    marginHorizontal: 16,
  }),
  detailsSecondExtraDescriptionStyle: theme => ({
    color: theme.colors.text.primary,
    fontSize: 16,
    marginTop: 4,
    textAlign: 'center',
    marginHorizontal: 16,
    fontWeight: 'bold',
  }),
  hintsContainerViewStyle: {
    flex: 1,
    marginRight: 19,
    marginLeft: 16,
    alignItems: 'flex-start',
    marginTop: 31,
    alignSelf: 'flex-start',
  },
  primaryButton: {
    marginTop: 32,
    marginHorizontal: 16,
  },
  secondaryButton: {
    marginTop: 16,
    marginBottom: 40,
    marginHorizontal: 16,
  },
  networkIconStyle: {
    alignSelf: 'center',
  },
  tutorialIconStyle: {
    height: 336,
    marginTop: 33.2,
    width: '100%',
  },
  privacyPolicyHyperlinkStyle: theme => ({
    color: theme.colors.hyperlinkFive,
    textAlign: 'center',
    fontSize: 16,
    marginTop: 25,
    marginBottom: 48,
  }),
});
